import { PermissionName } from '@sironamedical/common/constants/permissionName';
import { FF, useFeatureFlagEnabled } from 'modules/feature-flags';
import { useValidateUserHasRbacPermissions } from 'hooks/useValidateUserHasRbacPermissions';

/**
 * Whether the user can filter and sort the main worklist.
 *
 * Only enforced while `WORKLIST_FILTER_SORT_BY_ROLE` is on. With the flag off everyone can,
 * as today. The backend does not check this, so the worklist UI and requests must.
 */
export const useHasWorklistFilterSortPermission = (): boolean => {
  const [isPermissionEnforced] = useFeatureFlagEnabled(FF.WORKLIST_FILTER_SORT_BY_ROLE);
  const hasFilterSortPermission = useValidateUserHasRbacPermissions({
    permissionNames: [PermissionName.WorklistFilterSort],
  });

  return !isPermissionEnforced || hasFilterSortPermission;
};
